import { LOGIN } from '../../store/actions';
import { component, state, action, getter } from '../../decorators';

@component
export default class Login {
   username = ''
   password = ''

   @getter() getRedirectUrl

   /** @type {Boolean} */
   @state('auth.loading') inprocess
   /** @type {Function} */
   @action(LOGIN) login

   onlogin() {
      this.login({ username: this.username, password: this.password });
   }

   created() {
      const url = this.$store.state.settings.redirectUrl;
      if ( url ) {
         window.location = url;
      }
   }
}
